package com.downdogapp.client.views

import com.downdogapp.*
import com.downdogapp.client.View
import com.downdogapp.client.controllers.SignInViewController

expect class SignInView(controller: SignInViewController) : View {

  val email: String
  val password: String

  fun showSpinner()
  fun hideSpinner()
  fun focusEmail() // android and ios
}

object SignInViewConstants {

  val roundedButtonHeight = 50
  val contentWidth = 380
  val fadeDuration = seconds(0.25)
}
